<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="80%"
    top="60px"
    :fullscreen="dialogFull"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :before-close="handleClose"
    append-to-body
    :modal-append-to-body="false"
  >
    <template slot="title">
      <div class="avue-crud__dialog__header">
        <span class="el-dialog__title">
         参数配置
        </span>
        <i
          class="el-icon-full-screen"
          style="margin-right: 20px; position: relative; top: -1px"
          @click="dialogFull = !dialogFull"
        ></i>
      </div>
    </template>
    <div
      class="content-create-car-page"
      :style="'height:' + dialogBodyHight + 'px;overflow:scroll;'"
    >

      <div class="right" style="margin-left: 10px">
        <ninth
          v-if="showninth"
         :saveBtnShow.sync="saveBtnShow"
         :parkSpace="parkSpace"
         @getQuestionResult="getQuestionResult"
         ref="ninth"
       ></ninth>
      </div>
    </div>
    <template slot="footer">
      <el-button
        @click="formSubmit"
        size="small"

        type="primary"
        ><span class="el-icon-circle-plus-outline"></span> 保存</el-button
      >

    </template>
  </el-dialog>
</template>
<style lang="scss" scoped>
.content-create-car-page {
  display: flex;
  width: 100%;
  .left {
    width: 110px;
    flex-shrink: 0;
    flex-grow: 0;
  }
  .right {
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
    margin-left: 10px;
    width: 200px;
    flex-shrink: 1;
    flex-grow: 1;
    background-color: #fff;
  }
}
</style>
<script>

import ninth from './i-parameter.vue';

import { getCreateStage, saveCreateStage } from '@/views/v4ward/carv2/merge/api/park-merge.js';
export default {
  components: {  ninth },
  data() {
    return {
      showninth:false,
      model: 'add',
      saveBtnShow: true,
      parkSpace: {},
      dialogVisible: false,
      dialogFull: false,
      defaultSaveBtns: ['second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth'],
    };
  },
  computed: {
    dialogBodyHight() {
      if (this.dialogFull) {
        return this.bodyHeight - 180;
      } else {
        return this.bodyHeight - 270;
      }
    },
  },
  methods: {
    openDialog(type, row) {
      console.log(type);
      if (type == 'add') {
        this.model = type;
        this.activeNameList.forEach((ele) => {
          if (ele.value != 'first') {
            ele.disabled = true;
          }
        });
        console.log(this.activeNameList);
        this.saveBtnShow = true;
        this.dialogVisible = true;
      } else {
        this.model = type;
        this.parkSpace = row;
        this.dialogVisible = true;
        getCreateStage({ spaceId: this.parkSpace.id, tenantId: this.parkSpace.tenantId }).then(
          (res) => {
            if (!res.data) {
              this.activeNameList.forEach((ele) => {
                ele.disabled = false;
              });
            } else {
              this.activeNameList = JSON.parse(res.data);
            }
            this.showninth=true
            setTimeout(() => {
              this.$refs.ninth.onLoad(this.parkSpace.id);
              
            });
          }
        );
      }
      this.activeName = 'first';
    },
    nextStep(over) {
      if (over) {
        this.dialogVisible = false;
        this.$emit('onload');
      } else {
        this.$refs[this.activeName].formSubmit(true);
      }
    },
    formSubmit() {
      console.log(this.$refs);
      this.$refs['ninth'].formSubmit();
    },
    handleClick() {
      if (this.defaultSaveBtns.indexOf(this.activeName) > -1) {
        this.saveBtnShow = false;
      } else {
        this.saveBtnShow = true;
      }
    },
    getNewSpaceDetails(parkSpace) {
      this.parkSpace = parkSpace;
    },
    getQuestionResult(result) {
      if (result) {
        let activeNameIndex = 0;
        this.activeNameList.forEach((ele, index) => {
          if (ele.value == this.activeName) {
            activeNameIndex = index;
            if (index != 9) {
              this.activeNameList[index + 1].disabled = false;
            }
          }
        });
        activeNameIndex += 1;
        console.log(activeNameIndex);
        this.activeName = this.activeNameList[activeNameIndex].value;
        if (this.defaultSaveBtns.indexOf(this.activeName) > -1) {
          this.saveBtnShow = false;
        } else {
          this.saveBtnShow = true;
        }
      }
      let form = {
        spaceId: this.parkSpace.id,
        tenantId: this.parkSpace.tenantId,
        createStage: JSON.stringify(this.activeNameList),
      };
      saveCreateStage(form).then((res) => {});
    },
    // 弹窗关闭前
    handleClose(done) {
      let self = this;
      this.$confirm('确认关闭?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          if (done) {
            done();
          }
          this.$emit('onload');
            this.showninth = false;
          self.dialogVisible = false;
        })
        .catch(() => {});
    },
  },
  
};
</script>
